__turbopack_context__.v({
  "Channel": "chatter-sales-report-tooltip-module__pGvn2q__Channel",
  "Tooltip": "chatter-sales-report-tooltip-module__pGvn2q__Tooltip",
});
